import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS, SERVICES, SITE } from "../lib/data";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-black/10 bg-ink-surface">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-2 lg:grid-cols-4 lg:px-8 lg:py-20">
      <div>
        <Logo />
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-mist">
          Commercial contracting and facility-maintenance services for petroleum retail
          locations across Ontario.
        </p>
      </div>

      <div>
        <h3 className="mb-5 text-xs font-bold uppercase tracking-[0.3em] text-neutral-400">
          Navigation
        </h3>
        <ul className="space-y-3">
          {NAV_LINKS.map((link) => (
            <li key={link.href}>
              <Link
                to={link.href}
                data-testid={`footer-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-neutral-600 transition-colors hover:text-ember"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="mb-5 text-xs font-bold uppercase tracking-[0.3em] text-neutral-400">
          Services
        </h3>
        <ul className="space-y-3">
          {SERVICES.map((s) => (
            <li key={s.title}>
              <Link
                to="/services"
                data-testid={`footer-service-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="text-sm text-neutral-600 transition-colors hover:text-ember"
              >
                {s.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="mb-5 text-xs font-bold uppercase tracking-[0.3em] text-neutral-400">
          Contact
        </h3>
        <p className="flex items-start gap-3 text-sm leading-relaxed text-neutral-600">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-ember" />
          <span>
            {SITE.name}
            <br />
            {SITE.addressLine1}
            <br />
            {SITE.addressLine2}
          </span>
        </p>
        <a
          href={SITE.phoneHref}
          data-testid="footer-phone-link"
          className="mt-5 flex items-center gap-3 font-display text-lg font-bold text-coal transition-colors hover:text-ember"
        >
          <Phone className="h-4 w-4 text-ember" />
          {SITE.phone}
        </a>
      </div>
    </div>

    <div className="border-t border-black/10">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-5 py-6 text-xs text-neutral-400 sm:flex-row sm:items-center lg:px-8">
        <p data-testid="footer-copyright">© 2026 Petroline Services. All Rights Reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors hover:text-ember">
            Privacy Policy
          </Link>
          <Link to="/terms" data-testid="footer-terms-link" className="transition-colors hover:text-ember">
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
